import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { getOneProduct, getProductLike, getProductYouLike } from '../../redux/actions/productsAction';
import emptyImage from '../../images/icons8-image-100.png'
import { getOneCategory } from '../../redux/actions/categoryAction';
import { getOneBrand } from '../../redux/actions/brandAction';
const ViewProductsDetalisHook = (prodID) => {

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getOneProduct(prodID))
    }, [])

    const oneProducts = useSelector((state) => state.allproducts.oneProduct)
    const oneCategory = useSelector((state) => state.allCategory.oneCategory)
    const oneBrand = useSelector((state) => state.allBrand.oneBrand)
    const productLike = useSelector((state) => state.allproducts.productLike)
    //     //to show products item
    var item = [];
    try {
        if (oneProducts.data) {
            item = oneProducts.data
        }
    } catch (error) {

    }


    useEffect(() => {
        if (item.category) {
            dispatch(getOneCategory(item.category._id))
        }
        if (item.brand) {
            dispatch(getOneBrand(item.brand))
        }
        if (item.category) {
            dispatch(getProductLike(item.category._id))
        }

    }, [item])



    //     //to show category item
    let cat = [];
    try {
        if (oneCategory.data)
            cat = oneCategory.data;
        else
            cat = []

    } catch (error) {

    }



    //     //to show brand item
    let brand = [];
    try {
        if (oneBrand.data) {
            brand = oneBrand.data;
        }
        else {
            brand = []
        }
    } catch (error) {

    }
    //     //to view images gallery
    let images = []


    try {
        if (item.image) {
            images.unshift({ original: `${item.image}` })
        }
        if (item.images) {
            item.images.forEach((im) => {
                images.push({
                    original: im
                })
            })
        }
        else {
            images = [{ original: `${emptyImage}` }]
        }
    } catch (error) {

    }


    let prod = []
    try {
        if (productLike) {
            prod = productLike.data;
        }

        else
            prod = []
    } catch (error) {

    }

    return [item, images, cat, brand, prod]
}

export default ViewProductsDetalisHook